import {
  fetchReservationData,
  updateBrandCode,
  updatePrearrivalSession,
  type PrearrivalSessionData,
} from '../api/reservationService';

export const fetchReservationSpecificData = async (marshaCode: string, confirmationNumber: string) => {
  const offersResponse = await fetchReservationData(marshaCode, confirmationNumber);
  return offersResponse;
};

export const updateBrandCodeSessionData = async (brandCode: string, sessionToken?: string) => {
  const sessionUpdateResponse = await updateBrandCode(brandCode, sessionToken);
  return sessionUpdateResponse;
};

export const updatePrearrivalSessionData = async (
  prearrivalSessionData: PrearrivalSessionData,
  sessionToken?: string,
  requestId = ''
) => {
  const sessionUpdateResponse = await updatePrearrivalSession(prearrivalSessionData, sessionToken, requestId);
  return sessionUpdateResponse;
};
